import { memo } from 'react';
import _ from 'lodash';

import DealsStatistics from './DealsStatistics.react';
import ReservationManipulation from './ReservationManipulation.react';

const DealsStatisticsSection = ({
	hotelDeals,
	reservationManipulation,
	profile,
	displayDebugging,
	dynamicPriceIdFilter,
	onShowSupersededDeals,
	onFilterByDynamicPriceId,
	onInitStatusChange,
	onRecheckChange,
	onPriceChange,
}) => {
	const countByRoomGroup = _.countBy(hotelDeals, 'room_group');
	const numGroups = Object.keys(countByRoomGroup).length;
	const numHotelDeals = hotelDeals ? Object.keys(hotelDeals).length : 0;
	const supersededNum = hotelDeals ? hotelDeals.filter((d) => d.superseded).length : 0;

	return (
		<div>
			<DealsStatistics
				deals={numHotelDeals}
				groups={numGroups}
				superseded_num={supersededNum}
				showSupersededDealsCallback={onShowSupersededDeals}
				display_debugging={displayDebugging}
				onFilterByDynamicPriceId={onFilterByDynamicPriceId}
				dynamicPriceIdFilter={dynamicPriceIdFilter}
			/>
			<ReservationManipulation
				profile={profile}
				reservation_manipulation={reservationManipulation}
				onInitStatusChange={onInitStatusChange}
				onRecheckChange={onRecheckChange}
				onPriceChange={onPriceChange}
			/>
		</div>
	);
};

export default memo(DealsStatisticsSection);
